import { render, staticRenderFns } from "./dealerInfo.vue?vue&type=template&id=243ba5cb&scoped=true"
import script from "./dealerInfo.vue?vue&type=script&lang=js"
export * from "./dealerInfo.vue?vue&type=script&lang=js"
import style0 from "./dealerInfo.vue?vue&type=style&index=0&id=243ba5cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243ba5cb",
  null
  
)

export default component.exports